var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.054,
    height: 13.391,
    viewBox: "0 0 18.054 13.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#33475b;stroke:#33475b;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 -67.747)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 67.997)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.3,68.255a.878.878,0,0,0-1.241,0L5.54,78.77,1.5,74.728A.878.878,0,0,0,.257,75.969l4.662,4.662a.878.878,0,0,0,1.241,0L17.3,69.5A.878.878,0,0,0,17.3,68.255Z",
    transform: "translate(0 -67.997)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.cdb00df6696a4c7f969088892963334d.svg";
export { ForwardRef as ReactComponent };